import React, { useEffect, useState } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";
import WhiteLoader from "../Common/WhiteLoader";

const NumberOfActivePos = () => {
  const [numberOfActivePos, setNumberOfActivePos] = useState([]);
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingNum, setIsLoadingNum] = useState(false);

  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };

  useEffect(() => {
    axios
      .get(`${dashboardURL}/number-of-activated-pos`, config)
      .then((result) => {
        setNumberOfActivePos(result.data.number);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
    if (localStorage.getItem("liveReload") === "true") {
      setIsLoading(false);
      const interval = setInterval(() => {
        setIsLoadingNum(true);
        axios
          .get(`${dashboardURL}/number-of-activated-pos`, config)
          .then((result) => {
            setNumberOfActivePos(result.data.number);
            setIsLoadingNum(false);
          })
          .catch((err) => console.log(err.response));
      }, 30000);
      return () => clearInterval(interval);
    } else {
      axios
        .get(`${dashboardURL}/number-of-activated-pos`, config)
        .then((result) => {
          setNumberOfActivePos(result.data.number);
          setIsLoading(false);
        })
        .catch((err) => console.log(err.response));
    }
  }, []);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-pos">
            <div className="dashboard-card-body-pos-image">
              <span
                className="icon icon-cash-register"
                style={{ fontSize: 85 }}
              ></span>
            </div>
            <div className="dashboard-card-body-pos-simpleData">
              {isLoadingNum ? <WhiteLoader /> : numberOfActivePos}
            </div>
          </Card.Body>
          <Card.Footer className="dashboard-card-footer-pos">
            {translator("Dashboard-TotalNumberOfPos-Title")}
          </Card.Footer>
        </>
      )}
    </>
  );
};

export default NumberOfActivePos;
